import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import commonService from 'utils/commonService';

const RouteScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    commonService.scrollToTop();
  }, [pathname]);

  return null;
};

export default RouteScrollToTop;
